$(function () {

    function calculateCountDown(countDownDateTime, id, showYears) {
        const countDownDate = new Date(countDownDateTime);
        
        const now = new Date();
        const timeLeft = countDownDate - now;
        
        if (timeLeft <= 0) {
            $('.section_' + id).find('.js-countdown-running').toggleClass("hide-container");
            $('.section_' + id).find('.js-countdown-complete').toggleClass("hide-container");
            return true;
        }
        
        const years = showYears ? Math.floor(timeLeft / (1000 * 60 * 60 * 24 * 365)) : 0;
        const days = showYears ? Math.floor((timeLeft % (1000 * 60 * 60 * 24 * 365)) / (1000 * 60 * 60 * 24)) : Math.floor(timeLeft / (1000 * 60 * 60 * 24)) ;
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        if (showYears) {
            $('.js-years-' + id).find("span.big-number").html(years);
        }
        
        $('.js-days-' + id).find("span.big-number").html(days);
        $('.js-hours-' + id).find("span.big-number").html(hours);
        $('.js-minutes-' + id).find("span.big-number").html(minutes);
        $('.js-seconds-' + id).find("span.big-number").html(seconds);
    }

    window.calculateCountDown = calculateCountDown;
});